export default __webpack_public_path__ + "static/de-9deab36f1fd1cc6db00de4dee5c1e463.svg";